// 只将当前站点、当前网站应用中的服务平台链接转换为内部路由。
export function isServicePath(path) {
  return path === '/service' || path.startsWith('/service/') || path === '/public/service/login'
}

export function getServiceRoute(value) {
  if (typeof value !== 'string' || !value.trim()) return ''
  const link = value.trim()
  const routePath = link.split(/[?#]/)[0]
  if (link.startsWith('/') && !link.startsWith('//') && isServicePath(routePath)) {
    return link
  }
  if (link.startsWith('#/')) {
    const route = link.slice(1)
    return isServicePath(route.split(/[?#]/)[0]) ? route : ''
  }

  try {
    const target = new URL(link, window.location.href)
    const normalizePath = path => path.replace(/\/index\.html$/, '/').replace(/\/$/, '')
    const applicationPath = normalizePath(window.location.pathname)
    if (target.origin !== window.location.origin ||
        ![applicationPath, '/website'].includes(normalizePath(target.pathname))) {
      return ''
    }
    const route = target.hash.slice(1)
    return isServicePath(route.split(/[?#]/)[0]) ? route : ''
  } catch (error) {
    return ''
  }
}

export function navigateToService(router, value, integrationEnabled = false) {
  if (!integrationEnabled) return false
  return openServiceRoute(router, value)
}

// 显式配置的内部页面按站内路由打开；公共布局仍由融合开关控制。
export function openServiceRoute(router, value) {
  const target = getServiceRoute(value)
  if (!target) return false
  const { route } = router.resolve(target)
  // 不接管其他应用或无法匹配到服务平台的链接。
  if (!route.matched.some(record => record.meta.section === 'service')) return false
  if (route.fullPath !== router.currentRoute.fullPath) {
    router.push(target).catch(error => {
      // 未登录时守卫跳转到登录页、连续点击取消旧导航均属正常导航结果。
      if (!['NavigationDuplicated', 'NavigationRedirected', 'NavigationCancelled'].includes(error.name)) {
        console.error('服务平台页面跳转失败:', error)
      }
    })
  }
  return true
}
